<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { ProtectionOnColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()
const iconColor = computed(
    () => theme.global.current.value.dark
        ? ProtectionOnColors.icon.dark
        : ProtectionOnColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? ProtectionOnColors.background.dark
        : ProtectionOnColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="OneClickProtectionOn"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
